module.exports = __webpack_public_path__ + "img/routeCargo-logo.78e318a4.png";